import styled from '@emotion/styled';
import {
  Card,
  Spacing,
  StyledDiv,
  Typography,
  Skeleton,
} from '@taleemabad/dsm/components';
import { BreakpointSizes, mq } from '@taleemabad/dsm/themes';

export interface ScheduledSchool {
  emis: string;
  name: string;
  observationsPlanned: number;
  totalObservations: number;
}

export interface CoachScheduleOverviewProps {
  dateRange: string;
  schools: ScheduledSchool[];
  onSchoolClick: (school: ScheduledSchool) => void;
}

export const CoachScheduleOverview = ({
  dateRange,
  schools,
  onSchoolClick,
}: CoachScheduleOverviewProps) => (
  <StyledDiv
    flexDirection="column"
    width="100%"
    padding="0 0 var(--rk-spacing-xxxxxl) 0"
    gap={16}
  >
    <Typography variant="textBodyMediumOnSurfaceVariant" textAlign="center">
      Schedule visits for the following schools
    </Typography>

    <StyledCardsContainer>
      {schools.length === 0 ? (
        <Typography variant="textBodyMediumOnSurfaceVariant" textAlign="center">
          No schools assigned.
        </Typography>
      ) : (
        schools.map((school) => (
          <Card
            key={school.emis}
            variant="outline"
            minHeight="60px"
            onClick={() => onSchoolClick(school)}
          >
            <StyledCardContent>
              <StyledDiv flexDirection="column" gap={4}>
                <Typography variant="textLabelLarge">
                  EMI {school.emis}
                </Typography>
                <Typography variant="textTitleMedium">
                  {school.name === '__LOADING__' ? (
                    <Skeleton
                      variant="text"
                      width="200px"
                      height="20px"
                      animation="wave"
                    />
                  ) : (
                    school.name
                  )}
                </Typography>
              </StyledDiv>
              <Typography variant="textBodyMediumOnSurfaceVariant">
                Observations Planned: {school.observationsPlanned}/
                {school.totalObservations}
              </Typography>
            </StyledCardContent>
          </Card>
        ))
      )}

      <Spacing marginBottom="xxxxxxl" />
    </StyledCardsContainer>
  </StyledDiv>
);

const StyledCardsContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--rk-spacing-md);

  ${mq(BreakpointSizes.desktop)} {
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;
  }
`;

const StyledCardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--rk-spacing-md);
`;
